//# sourceURL=validate.js
(function ($) {

    $.fn.symValidate = function (method) {
        // Method calling logic
        if (methods[method]) {
            return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
        } else if (typeof method === 'object' || !method) {
            return methods.init.apply(this, arguments);
        } else {
            $.error('Method ' + method + ' does not exist on jQuery.symValidate');
        }
    };

    var methods = {
        init: function init(options) {

            if ($(this).hasClass("symValidate")) {
                return;
            }

            return this.each(function () {
                var $this = $(this);
                // Attempt to grab saved settings, if they don't exist we'll get "undefined".
                var settings = $this.data('symValidate');

                // If we could't grab settings, create them from defaults and passed options
                if (typeof settings === 'undefined') {

                    var defaults = {
                        dynamicEval: true,
                        showerrormodal: true,
                        validateoninit: false
                    };

                    settings = $.extend({}, defaults, options);

                    // Save our newly created settings
                    $this.data('symValidate', settings);
                } else {
                    // We got settings, merge our passed options in with them (optional)
                    settings = $.extend({}, settings, options);

                    // If you wish to save options passed each time, add:
                    // $this.data('pluginName', settings);
                }

                $this.addClass("symValidate");


                // Scan for common attributes elements
                $(this.attributes).each(function () {
                    // this.attributes is not a plain object, but an array
                    // of attribute nodes, which contain both the name and value
                    if (this.specified && this.name.startsWith('data-val')) {
                        var name = this.name.replace('data-val-', '');
                        var value = this.value;
                        if (value === "true" || value === "false") {
                            value = value === "true" ? true : false;
                        }
                        settings[name] = value;
                    }
                });

                // Validation sumary

                if ($this.find('.alert-validation-invalid').length === 0) {
                    $this.find(".form-group:last").after('<div class="alert alert-danger alert-validation-invalid d-none"><p>Hay errores en el formulario:</p></div>');
                }


                // Submit button
                $this.on("click", ".btn-submit", function () {
                    var $button = $(this);
                    $this.find('.alert-validation-invalid ul').empty();
                    return $this.symValidate('validate', true, function (result, data) {
                        
                        var buttonId; 
                        if (result === 1) {
                            buttonId = $button.attr('id') || ""; // Evita error en caso botón no tenga id
                            $this.trigger("valid", [$this.serializeObject(settings.returnprefix)]);
                            if (buttonId.length > 0) {
                                $this.trigger("valid-for-" + $button.attr("id"), [$this.serializeObject(settings.returnprefix)]);
                            }
                        } else {
                            buttonId = $button.attr('id') || ""; // Evita error en caso botón no tenga id
                           $this.trigger("invalid", []);

                            if (buttonId.lenght > 0) {
                                $this.trigger("invalid-for-" + $button.attr("id"), [$this.serializeObject()]);
                            }
                        }
                    });
                });

                if (settings.dynamicEval) {
                    $this.find('[data-val="true"]')
                        .on("focusin", function () {
                            $this.symValidate('validateItem', this);
                        })
                        .on("focusout", function () {
                            $this.symValidate('validateItem', this);
                        })
                        .on("keyup", function () {
                            $this.symValidate('validateItem', this);
                        })
                        .on("input", function () {
                            $this.symValidate('validateItem', this);
                        })
                        .on("change", function () {
                            $this.symValidate('validateItem', this);
                        })
                        .on("click", function () {
                            $this.symValidate('validateItem', this);
                        });
                }

                if (settings.validateoninit) {
                    $this.symValidate('validate', false);
                }

                //console.log(settings);

            });
        },

        validate: function (resolve, callback) {
            // For compatibility
            if (typeof resolve === 'object') {
                callbacks = resolve;
                resolve = true;
            }

            var $this = $(this);
            $this.find('.alert-validation-invalid').addClass("d-none");

            $this.find("[data-val='true']").each(function () {
                $this.symValidate('validateItem', this);
            });

            if (resolve) {
                var settings = $this.data('symValidate');
                if ($this.find(".is-invalid").length === 0) {
                    if (typeof callback === 'function') {
                        callback(1, $this.serializeObject(settings.returnprefix));
                    }
                } else {
                    $this.find('.alert-validation-invalid').removeClass("d-none");
                    $this.find('.alert-validation-invalid').fadeOut(6400, function () {
                        $(this).addClass("d-none");
                        $(this).css("display", "");
                    });
                    if (typeof callback === 'function') {                      
                        console.log(settings);
                        callback(0, settings);
                    }
                }
            }

            return false;

        },

        validateItem: function (elem) {
            var $this = $(this); // form

            var $elem = $(elem);
            var value = $elem.val();

            // Has elem 
            var elemName = $elem.prop("name");
            var $elemFormGroup = $elem.closest(".form-group");
            if ($elemFormGroup.find('[data-valmsg-for="{0}"]'.format(elemName)).length === 0) {
                $elemFormGroup.append('<span class="text-danger field-validation-valid" data-valmsg-for="{0}" data-valmsg-replace="true"></span>'.format(elemName));
            }

            var $message = $('[data-valmsg-for="' + elemName + '"]');

            // Reset

            $message.text("");
            $elem.removeClass("is-invalid");
            $elem.addClass("is-valid");

            // Test

            var regexMail = /^([a-zA-Z0-9_.+-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;

            var test = [
                ["data-val-equalto", value !== $this.find('[name$="' + ($elem.attr("data-val-equalto-other") || "").replace("*.", "") + '"]').val()],
                ["data-val-email", regexMail.test(value) === false, "No parece una dirección de e-mail válida"],
                ["data-val-length", value.length > 0 && value.length < parseInt($elem.attr("data-val-length-min") || 0)],
                ["data-val-any-number", /\d/.test(value) === false,],
                ["data-val-any-symbol", /\W/.test(value) === false,],
                ["data-val-any-upper", /[A-Z]/.test(value) === false,],
                ["data-val-any-lower", /[a-z]/.test(value) === false],
                ["data-val-length", value.length > parseInt($elem.attr('maxlength')), function () { return $this.symValidate('getMaxLengthMessage', $elem); }],
                ["data-val-range", parseInt(value) < parseInt($elem.attr('data-val-range-min')) || parseInt(value) > parseInt($elem.attr('data-val-range-max'))],
                ["data-val-required", value.length === 0, function () { return $this.symValidate('getRequiredMessage', $elem); }],
                ["data-val-mustbetrue", !$elem.prop("checked")],
                ["data-val-requiredIfCategory", value.length === 0 && ($elem.attr('data-val-requiredifcategory-values') || "").indexOf($this.find('#' + $elem.attr('data-val-requiredifcategory-object')).val()) > -1]
            ];

            $elem.closest(".form-group").removeClass("is-invalid");
            $.each(test, function () {
                if (typeof $elem.attr(this[0]) !== typeof undefined) {
                    
                  /*  if (this[0] === "data-val-requiredIf") {
                        console.log($elem);
                        console.log("value:", $elem.val());
                        console.log($this.find('#' + $elem.attr('data-val-requiredif-object')));
                        console.log($this.find('#' + $elem.attr('data-val-requiredif-object')).val());
                      
                    } */

                    var result;

                    if ($.isFunction(this[1])) result = this[1]($this, $elem)
                    else result = this[1];

                    if (result) {
                        $elem.addClass("is-invalid").removeClass("is-valid");
                        var mess = this[2] || $elem.attr(this[0]);
                        $message.text(mess);
                        $elem.closest(".form-group").addClass("is-invalid");
                        $this.symValidate("addError", mess);

                        console.log($elem);
                    }
                }
            });
        },

        addError: function (string) {
            var $this = $(this);
            var $alert = $this.find('.alert-validation-invalid');
            var $ul = $alert.find("ul");
            if ($ul.length === 0) {
                $ul = $("<ul></ul>");
                $alert.append($ul);
                $ul = $alert.find("ul");
            }
            var $li = $("<li></li>");
            $li.text(string);
            $ul.append($li);
        },

        getMaxLengthMessage: function ($elem) {
            var name = $elem.attr("data-displayname") === "" ? $elem.prop("name") : $elem.attr("data-displayname");
            return "El texto de " + name + " no puede superar los " + $elem.attr('maxlength') + " caracteres (tiene " + $elem.val().length + ")";

        },

        getRequiredMessage: function ($elem) {
            if ($elem.attr("data-val-required").indexOf('required') > -1) {
                return "Este campo necesita un valor";
            } else { return $elem.attr("data-val-required"); }
        },

        requireIfValidate: function ($elem) {
            return value.length === 0 && $this.find('#' + ($elem.attr('data-val-requiredif-object')).val() || "").toString().toLocaleLowerCase() === ($elem.attr('data-val-requiredif-value') || "").toString().toLocaleLowerCase()
        }


    };

   

})(jQuery);



